module.exports = __webpack_public_path__ + "img/metal_ae@2x.098a973d.png";